export const UrlRegex = {
  ASSESSMENT_PA_PRAGMAPOWER_DEFINITIONS_REGEX:
    /\/assessments-pa\/api\/v2\/pragmapower-definitions\?/,
  SCHEDULE_EVENTS_REGEX: /\/schedule\/api\/v1\/events/,
  VALORATION_STATUS_ACTIVE_REGEX: /\/valoration\/get-status-active/,
  BEHAVIORS_REGEX: /\/api\/v1\/behaviors/,
  GOAL_SCHEDULE_REGEX: /\/goals\/\d+(\/schedule\/preview)?(\?|$)/,
  CREATE_PRAGMAPOWER_REGEX: /\/api\/v1\/pragmapowers(\?|$)/,
  SCHEDULE_PUBLISH_MAP_REGEX: /\/chapter-speciality-technology-maps\/schedule-publish(\?|$)/,
  IAEVA_TRIGGER_REGEX: /\/ia-eva\/(trigger|start-valoration)(\?|$)/,
};
